import styled from 'styled-components/macro';
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";
import {useState} from "react";
import {useFeedback} from "../../../store/feedback";
import {useSaveFlairs} from "../../../api/moderation";

const EditPostFlair = styled(({className, communityFlairs, setCommunityFlairs, community, i, onClose}) => {
    const {feedbackCh} = useFeedback();
    const saveFlairs = useSaveFlairs(feedbackCh);
    const [flairs, setFlairs] = useState(communityFlairs);
    const [flairText, setFlairText] = useState(i !== -1 ? flairs[i].text : "");
    const [flairClass, setFlairClass] = useState(i !== -1 ? flairs[i].class : "");
    const [saving, setSaving] = useState(false);
    const handleSave = async (type) => {
        const f = [... flairs];
        let updated;
        const flairObj = {"text": flairText, "class": flairClass};
        if (i === -1) {
            // add new
            updated = [...f, flairObj];
        } else if (type === 'delete') {
            // delete
            updated = f.filter((_, index) => index != i);
        } else {
            // replace
            f[i] = flairObj;
            updated = f;
        }
        // save to API
        await saveFlairs(JSON.stringify(updated), community);
        setCommunityFlairs(updated);
        setSaving(false);
        onClose();
    }
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{i === -1 ? 'Add' : 'Edit'} Flair</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <FormControl pb={4}>
                        <FormLabel>Flair Text</FormLabel>
                        <Input
                            value={flairText}
                            onChange={(e) => setFlairText(e.currentTarget.value)}
                            maxLength="64"
                            autoComplete="off"
                            placeholder="Funny"
                            type="text"
                            required
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>CSS Class</FormLabel>
                        <Input
                            value={flairClass}
                            onChange={(e) => setFlairClass(e.currentTarget.value)}
                            maxLength="64"
                            autoComplete="off"
                            placeholder="funny"
                            type="text"
                            required
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    {i !== -1 &&
                    <Button variant="cancel" mr={3} onClick={() => handleSave('delete')}>Delete</Button>
                    }
                    <Button variant="blue" onClick={() => handleSave('update')}>
                        Save
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
})`
`;

export default EditPostFlair;
